"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Reddit = function (props) {
  var _a;

  return react_1.default.createElement("svg", {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-1221",
    d: "M48,24c0-3.309-2.691-6-6-6c-1.202,0-2.342,0.365-3.331,1.03c-3.605-2.257-8.24-3.743-13.208-3.989l3.152-7.881l7.418,1.648 C36.193,11.145,38.124,13,40.5,13c2.481,0,4.5-2.019,4.5-4.5S42.981,4,40.5,4c-1.89,0-3.504,1.174-4.17,2.827L27.387,4.84 l-4.069,10.173c-5.26,0.122-10.193,1.644-13.986,4.018C8.343,18.365,7.203,18,6,18c-3.309,0-6,2.691-6,6 c0,1.779,0.771,3.416,2.113,4.558C2.04,29.034,2,29.516,2,30c0,7.72,9.869,14,22,14s22-6.28,22-14c0-0.484-0.039-0.965-0.113-1.441 C47.229,27.416,48,25.779,48,24z M40.5,6C41.879,6,43,7.121,43,8.5S41.879,11,40.5,11S38,9.879,38,8.5S39.121,6,40.5,6z M2,24 c0-2.205,1.794-4,4-4c0.528,0,1.035,0.113,1.511,0.309c-2.205,1.725-3.87,3.768-4.766,5.98C2.277,25.625,2,24.842,2,24z M24,42 C12.972,42,4,36.617,4,30c0-6.926,9.346-13,20-13s20,6.074,20,13C44,36.617,35.028,42,24,42z M45.255,26.289 c-0.896-2.213-2.561-4.256-4.767-5.98C40.965,20.113,41.473,20,42,20c2.206,0,4,1.795,4,4C46,24.842,45.724,25.626,45.255,26.289z M31.707,35.293c0.391,0.391,0.391,1.023,0,1.414C30.421,37.992,27.036,39,24,39s-6.421-1.008-7.707-2.293 c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0C18.405,35.99,21.047,37,24,37c2.953,0,5.595-1.01,6.293-1.707 C30.684,34.902,31.316,34.902,31.707,35.293z M17,30c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S18.657,30,17,30z M34,27 c0,1.657-1.344,3-3,3s-3-1.343-3-3s1.344-3,3-3S34,25.343,34,27z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-1221"
  }));
};